export default __webpack_public_path__ + "static/media/review-avatar-3.f9553472.png";